const cardsList = [
    {
        id: 1,
        name: "Alice in the Borderland",
        image: require("../assets/technitude/Alice_Borderland_1.jpeg"),
        details: "Venture Beyond Reality: 🌟 Alice in Borderlands Showdown – A World of Challenges, 👑 Kings, and 🃏 Faceas Awaits Your Mastery!",
        register: "https://docs.google.com/forms/d/e/1FAIpQLScbffX_ibbSd9an9VIEf21SJI4BzESlT0rw8pdZofbpDR_Ibg/viewform"
    },
    {
        id: 2,
        name: "Manhattan Project Trinity Test",
        image: require("../assets/technitude/Manhattan.jpeg"),
        details: "Experience history's groundbreaking moment at our Manhattan Project: Trinity Test event – where science, secrecy, and sheer power collide! 💣🔍🔐",
        register: "https://docs.google.com/forms/d/e/1FAIpQLScqWvPnP0tIGzpqsjUOi4ZShRwXJXDnEyUQBgBhJ51wIrOz7w/viewform"
    },
    {
        id: 3,
        name: "Race to the SAN ANDREAS Cities",
        image: require("../assets/technitude/Race_to_SA.jpeg"),
        details: "Buzz your way to victory in our high-tech Race to San Andreas Cities – where quick thinking meets lightning-fast reactions!",
        register: "https://docs.google.com/forms/d/e/1FAIpQLScRhYDdub8B-m9AQgf8JprPZLGjEExaCAdMwTMKLG3bAfccAw/viewform"
    },
    {
      id: 4,
      name: "Blind Coding",
      image: require("../assets/technitude/Blind_Coding.jpeg"),
      details: "Discover the true power of code beyond sight at our Blind Coding Marvel, as innovation knows no visual boundaries!🌐💡💻",
      register: "https://docs.google.com/forms/d/e/1FAIpQLSfaMx540h65BFGn4qz0SeEvrZxHWrPHhfAfJ9sR2_IT9OIACg/viewform"
    },
    {
      id: 5,
      name: "BGMI Championship",
      image: require("../assets/technitude/BGMI.jpeg"),
      details: "Step up for the BGMI challenge, where teams aim for excellence! Champions are forged through dedication, not fate. Your unwavering commitment leads to victory and a place among excellence.",
      register: "https://docs.google.com/forms/d/e/1FAIpQLSfUxlAhOHg5n4gSd0o_A_Lxh_lTsXMcmHUCdFOSKCvADRk4cA/viewform"
    },
    {
      id: 6,
      name: "Valorant",
      image: require("../assets/technitude/Valorant.jpeg"),
      details: "Get ready to lock and load for an intense Valorant Championship! Show your skills, strategize with your team, and seize victory in this thrilling online event. Remember, it's not just about the game; it's about claiming your place on the winner's podium. Aim high, shoot higher! 🎯",
      register: "https://docs.google.com/forms/d/e/1FAIpQLSeIwk0LGYi94KidbJFoAJ92zixdc47OuDKuC4yqdDu_miBPfw/viewform"
    },
    {
      id: 7,
      name: "NEON Cricket",
      image: require("../assets/technitude/NEON_Cricket.jpeg"),
      details: "Elevate your sportsmanship experience with Neon Cricket – where skills and radiance collide for a match like no other! Come and play an exciting form of cricket with neon light and darkness ! 💥\n Register Now!!",
      register: "https://docs.google.com/forms/d/e/1FAIpQLSfJPo9IdIvLLfpUKO-AthpPLxy9fkAmc6pnfWbw0dDcU1WG4A/viewform"
    },
    {
      id: 8,
      name: "BOX Cricket",
      image: require("../assets/technitude/Box_Cricket.jpeg"),
      details: "Box Cricket: Think Inside the Box, Play Outside the Norm! Unleash the inner cricketer with an amazing opportunity to showcase your cricket skills.! 🎯",
      register: "https://docs.google.com/forms/d/e/1FAIpQLSfTM9cjlEO1jaXYIHOi7hkWNxz8rY_xUyidL6X-48Nvm2sxEg/viewform"
    },
    {
      id: 9,
      name: "Dynasty of Dance",
      image: require("../assets/technitude/Dynasty_of_Dance.jpeg"),
      details: "🎵✨Unveil your inner dancer and let the melodies guide your feet in a symphony of movement and grace 🕺💃",
      register: "https://docs.google.com/forms/d/e/1FAIpQLScRj7Wd6P58XV3BRltxyVWjOJ_LJastZoUHaNAIo_SuaXOTiQ/viewform"
    },
    {
      id: 10,
      name: "Rythmic Fusion",
      image: require("../assets/technitude/Rythmic_Fusion.jpeg"),
      details: "Buzz your way to victory in our high-tech Race to San Andreas Cities – where quick thinking meets lightning-fast reactions!",
      register: "https://docs.google.com/forms/d/e/1FAIpQLSclYiTsJEKMq_LOff5nwJipK5MUrFP-DsZUxO2upkRyu126sQ/viewform"
    }
  ];
  export default cardsList;